export default "__VITE_ASSET__B9W_6LHZ__"